import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "#fff",
  class: "fill-current",
  viewBox: "0 0 40 40"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M13.985 41.29c-.66 0-1.294-.271-1.761-.755a2.63 2.63 0 0 1-.73-1.825c0-.684.263-1.34.73-1.825a2.45 2.45 0 0 1 1.761-.756c3.356 0 3.524-3.038 3.524-3.651V18.774c0-.684.263-1.34.73-1.824A2.45 2.45 0 0 1 20 16.194c.66 0 1.294.272 1.761.756s.73 1.14.73 1.825v13.703c0 3.542-2.267 8.813-8.506 8.813" }, null, -1 /* HOISTED */),
    _createElementVNode("path", { d: "M40 20.645H0l.075-2.651C.367 7.904 9.122 0 20 0s19.633 7.903 19.925 17.994zm-34.558-5.16h29.116C33.008 9.6 27.01 5.161 20 5.161S6.993 9.6 5.442 15.484" }, null, -1 /* HOISTED */)
  ])))
}
export default { render: render }